<template>
  <div class="page height-full">
    <app-header title="Tasks"/>
    <b-modal ref="my-modal" hide-footer title="Create A Task">
      <b-form-group
        id="input-group-1"
        label="Task:"
        label-for="input-1"
      >
        <b-form-input
          id="input-1"
          v-model="form.name"
          type="text"
          required
          placeholder="Enter task"
        ></b-form-input>
      </b-form-group>

      <b-form-group 
        id="input-group-2" 
        label="Assigned To:" 
        label-for="input-2"
        description="Team member this task is assigned to.">
        <b-form-select
          id="input-2"
          v-model="form.store"
          :options="stores"
          required
        ></b-form-select>
      </b-form-group>
      <b-form-group 
        id="input-group-3" 
        label="Client Account:" 
        label-for="input-3"
        description="Client account the task belongs to.">
        <b-form-select
          id="input-3"
          v-model="form.store"
          :options="stores"
          required
        ></b-form-select>
      </b-form-group>
      <b-button v-if="isLoading == true" variant="primary" class="mt-3" block disabled>
        <b-spinner small type="grow"></b-spinner>
        Creating Form...
      </b-button>
      <b-button v-else class="mt-2" variant="primary" block @click="createForm()">Create Task</b-button>
    </b-modal>
    <div v-if="forms.length == 0">
      <div class="instructions-container">
        <h2>Create a Form</h2>
        <p>Build a unique acquisition funnel for new customers.</p>
        <b-btn variant="primary" @click="newForm()">New Form</b-btn>
      </div>
    </div>
    <b-card v-else>
      <div>
        <div><a href="#" @click="goBack" style="float: left;">&larr; Go Back</a></div>
        <b-button variant="primary" class="compose-btn" @click="showDialog = true" style="float: right; margin-bottom: 16px;">
          New Form
        </b-button>
        <b-table hover :items="items" :fields="fields">
          <template v-slot:cell(actions)="data">
            <div class="action-container" v-if="isOwner(data) == false">
             <b-dropdown
               variant="link"
               size="lg"
               toggle-class="text-decoration-none"
               no-caret
               right
             >
               <template slot="button-content">
                 <b>⋮</b>
               </template>
               <b-dropdown-item class="delete" @click="deleteUser(data)"><b-icon-trash></b-icon-trash><span>Remove User</span></b-dropdown-item>
             </b-dropdown>
            </div>
          </template>
        </b-table>
        <spinner v-if="isLoading"></spinner>
      </div>
    </b-card>
  </div>
</template>

<script>

  import Constants from './../Constants'
  import axios from 'axios'
  import Spinner from './common/Spinner'

  export default {
    name: "Tasks",
    components: {
      Spinner
    },
    data: () => {
      return {
        items: [],
        forms: [],
        isLoading: false,
        stores: [
          { value: 'cuvee', text: 'Cuveé Coffee' },
          { value: 'doomz', text: 'DoomzDNA' }
        ],
        form: {
          name: '',
          store: ''
        },
        fields: ['givenName', 'familyName', 'email', 'role', 'actions'],
        showDialog: false,
        showEditDialog: false,
        options: [
          { value: 'admin', text: 'Admin - All Access' },
          { value: 'agent', text: 'Agent - Send and receive messages' }
        ]
      }
    },
    methods: {
      async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      createForm() {
        this.isLoading = true
        this.sleep(2000).then(() => {
          window.location.href = '/forms/id/builder'
        })
      },
      newForm() {
        this.$refs['my-modal'].show()
      },
      goBack() {
        const id = this.$route.params.id
        this.$router.push('/admin')
      },
      deleteUser: function(data) {
        this.isLoading = true
        const id = data.item.sk.split('|')[1]
        axios.delete(Constants.API_URL + '/account/users/' + id)
          .then(response => {
            this.getUsers()
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      editUser: function(data) {
        console.log(data)
        this.selectedUser = data.item
        this.showEditDialog = true
      },
      updateRole: function(data) {
        const userId = this.selectedUser.sk.split('|')[1]
        this.isLoading = true
        axios.put(Constants.API_URL + "/account/users/" + userId, {role: this.form.role})
          .then((response) => {
            swal('Role Updated', 'Successfully updated user role to ' + this.form.role, 'success')
            this.close()
            this.getUsers()
          }).catch((err) => {
            swal('Error', 'Error Updating Role', 'error')
          }).then(() => {
            this.isLoading = false
          })
      },
      updatePhone(data) {
        this.form.phone = data.nationalNumber
        this.form.country = data.countryCallingCode
      },
      isOwner: function(data) {
        return data.item.role == "owner"
      },
      getUsers() {
        this.isLoading = true
        const id = this.$route.params.id
        axios
          .get(Constants.API_URL + '/accounts/' + id + '/clients')
          .then(response => {
            console.log(response);
            this.isLoading = false
            this.items = response.data.Items.map((item) => {
              item.phoneNumber = Constants.FORMAT_PHONE_NUMBER(item.sk.split("|")[1])
              return item
            })
            console.log(items)
          }).catch((err) => {
            console.log(err)
            this.isLoading = false
        })
      },
      reset() {
        this.form.country = "";
        this.form.name = "";
        this.form.ph = "";
        this.form.familyName = "";
        this.form.phone = "";
      },
      close() {
        this.reset();
        this.showDialog = false
      },
      save() {
        const params = {
          givenName: this.form.name,
          familyName: this.form.familyName,
          email: this.form.email,
        }

        console.log(params)
        const id = this.$route.params.id
        this.isLoading = true
        axios
          .post(Constants.API_URL + '/account/' + id + '/clients', params)
          .then(response => {
            console.log(response);
            this.close()
          }).catch((err) => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
            this.getUsers()
          })
      }
    },
    mounted() {
      this.getUsers()
    }
  }
</script>

<style scoped>
  .dialog-content {
    max-height: 600px;
    width: 500px;
  }

  .country-content {
    width: 100%;
  }

  .action-container {
    margin-top: -10px;
  }

  .delete {
    color: red;
  }

  .delete svg {
    margin-right: 8px;
    color: red;
  }

  .delete span {
    color: red;
  }

  .edit svg {
    margin-right: 8px;
  }

  .instructions-container {
    width: 100%;
    text-align: center;
    margin-top: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tasks.vue